import { Icon } from '@iconify/react';
import classnames from "classnames";
import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";

function NoData() {



  return (
    <section className={Styles.errorWrap}>
      <div className={Styles.errorMessage}>
        <Icon icon="fluent:calendar-search-20-regular"/>
        <h1>No Data</h1>
      </div>
    </section>
  )
}


export default NoData